import { useState, useEffect } from "react";
import * as S from "./styles";
import api from "../../api/api";
import {
  Loader2,
  DollarSign,
  Package,
  TrendingUp,
  Users,
} from "lucide-react";
import { toast } from "react-toastify";

const OrderHistory = () => {
  const [history, setHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filterPeriod, setFilterPeriod] = useState("hoje");

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        setIsLoading(true);
        const { data } = await api.get("/orders/completed");
        setHistory(Array.isArray(data) ? data : []);
      } catch (err) {
        toast.error("Erro ao sincronizar dados.");
      } finally {
        setIsLoading(false);
      }
    };
    fetchHistory();
  }, []);

  const getFilteredData = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return history.filter((order) => {
      const orderDate = new Date(order.created_at);
      orderDate.setHours(0, 0, 0, 0);

      if (filterPeriod === "hoje")
        return orderDate.getTime() === today.getTime();
      if (filterPeriod === "7dias") {
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(today.getDate() - 7);
        return orderDate >= sevenDaysAgo;
      }
      return true;
    });
  };

  const filteredData = getFilteredData();

  
  const totalRevenue = filteredData.reduce(
    (acc, item) => acc + (parseFloat(item.total_price) || 0),
    0,
  );
  const ticketMedio =
    filteredData.length > 0 ? totalRevenue / filteredData.length : 0;
  const uniqueCustomers = new Set(filteredData.map((o) => o.customer_name))
    .size;

  if (isLoading)
    return (
      <S.LoadingWrapper>
        <Loader2 className="animate-spin" size={48} />
      </S.LoadingWrapper>
    );

  return (
    <S.Container>
      <S.Header>
        <div className="title-area">
          <h2>Painel de Histórico</h2>
          <p>Análise detalhada de performance e vendas</p>
        </div>

        <S.SegmentedControl>
          <button
            className={filterPeriod === "hoje" ? "active" : ""}
            onClick={() => setFilterPeriod("hoje")}
          >
            Hoje
          </button>
          <button
            className={filterPeriod === "7dias" ? "active" : ""}
            onClick={() => setFilterPeriod("7dias")}
          >
            7 Dias
          </button>
          <button
            className={filterPeriod === "todos" ? "active" : ""}
            onClick={() => setFilterPeriod("todos")}
          >
            Histórico Total
          </button>
        </S.SegmentedControl>
      </S.Header>

      <S.StatsGrid>
        <div className="stat-card">
          <div className="icon-box green">
            <DollarSign size={20} />
          </div>
          <span>Faturamento</span>
          <h3>
            {totalRevenue.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}
          </h3>
        </div>

        <div className="stat-card">
          <div className="icon-box blue">
            <Package size={20} />
          </div>
          <span>Pedidos</span>
          <h3>{filteredData.length}</h3>
        </div>

        <div className="stat-card">
          <div className="icon-box purple">
            <TrendingUp size={20} />
          </div>
          <span>Ticket Médio</span>
          <h3>
            {ticketMedio.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}
          </h3>
        </div>

        <div className="stat-card">
          <div className="icon-box orange">
            <Users size={20} />
          </div>
          <span>Clientes Únicos</span>
          <h3>{uniqueCustomers}</h3>
        </div>
      </S.StatsGrid>

      <S.TableCard>
        <div className="table-header">
          <h4>Detalhamento de Transações</h4>
          <span
            style={{ color: "#94a3b8", fontSize: "0.85rem", fontWeight: 600 }}
          >
            {filteredData.length} resultados encontrados
          </span>
        </div>

        <S.MainTable>
          <thead>
            <tr>
              <th>ID</th>
              <th>Cliente</th>
              <th>Pagamento</th>
              <th>Valor</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((order) => (
              <tr key={order.id}>
                <td data-label="ID">
                  <strong>#{order.id}</strong>
                </td>
                <td data-label="Cliente">
                  <div className="customer-info">
                    <strong>{order.customer_name}</strong>
                    <small>
                      {new Date(order.created_at).toLocaleDateString()}
                    </small>
                  </div>
                </td>
                <td data-label="Pagamento">
                  <span className="payment-tag">{order.payment_method}</span>
                </td>
                <td data-label="Valor">
                  <S.PriceText>R$ {order.total_price}</S.PriceText>
                </td>
                <td data-label="Status">
                  <S.StatusBadge>CONCLUÍDO</S.StatusBadge>
                </td>
              </tr>
            ))}
          </tbody>
        </S.MainTable>
      </S.TableCard>
    </S.Container>
  );
};

export default OrderHistory;
